import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=11be5c8d&scoped=true&"
var script = {}
import style0 from "./SupportPage.vue?vue&type=style&index=0&id=11be5c8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11be5c8d",
  null
  
)

export default component.exports